<div class="row">
  <div class="col-lg-8 col-sm-6 col-md-6">
    <div class="d-flex justify-content-between custom-container">
      <nav class="custom-nav">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="cursor: pointer" (click)="back()">
            Dashboard
          </li>
          <li
            class="breadcrumb-item active"
            style="cursor: context-menu"
            aria-current="page"
          >
            Automated Bulk Upload
          </li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="col-lg-4 col-sm-6 col-md-6 overlay">
    <app-select-branch
      (OnBranchChangeData)="changeState($event)"
    ></app-select-branch>
  </div>
</div>

<div class="card card_outLine mt-3">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <h5 class="title_five">Automated Bulk Upload</h5>
        <p class="card-text text_p"></p>
      </div>
      <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
        <!-- <p-button
          label="Back"
          (click)="goBackToExcel()"
          styleClass="p-button-sm"
        ></p-button> -->
      </div>
    </div>
  </div>
</div>

<div class="card my-3 card_style_bs_order_cat card_outLine">
  <div class="card-body" style="padding-bottom: 0">
    <span class="title_five">Finish Setting Up in three simple Steps</span>
    <ul class="steps_style" style="padding-left: 0">
      <li
        [ngClass]="getStepClass(1)"
        class="col-lg-3 col-md-3 col-sm-4 col-6"
        [style.cursor]="canNavigateToStep(1) ? 'pointer' : 'default'"
        (click)="navigateToStep(1)"
      >
        1. Upload Excel
      </li>
      <li
        [ngClass]="getStepClass(2)"
        class="col-lg-3 col-md-3 col-sm-4 col-6"
        [style.cursor]="canNavigateToStep(2) ? 'pointer' : 'default'"
        (click)="navigateToStep(2)"
      >
        2. Upload PDF Documents
      </li>
      <li
        [ngClass]="getStepClass(3)"
        class="col-lg-3 col-md-3 col-sm-4 col-6"
        [style.cursor]="canNavigateToStep(2) ? 'pointer' : 'default'"
        (click)="navigateToStep(2)"
      >
        3. Order Confirmation
      </li>
    </ul>
  </div>
</div>
